import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { LecturerAvatarNameComponent } from 'src/app/shared/components/lecturer-avatar-name/lecturer-avatar-name.component';
import { ILocket } from 'src/app/shared/models/locket/locket.model';
import { ILecturer } from 'src/app/shared/models/user/lecturer/lecturer.model';
import { IUser } from 'src/app/shared/models/user/user.model';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';

@Component({
  selector: 'app-si-lecturer-item',
  standalone: true,
  imports: [
    TranslateModule,
    CheckboxModule, ButtonModule,
    LecturerAvatarNameComponent,
    NgbTooltipModule,
  ],
  templateUrl: './si-lecturer-item.component.html',
  styleUrl: './si-lecturer-item.component.scss'
})
export class SiLecturerItemComponent {

  @Input({required: true}) lecturer: (ILecturer & { user: IUser & { lockets: ILocket[] } }) | undefined;
  @Input({required: true}) orgId: number | undefined;
  @Input({required: true}) selected: boolean | undefined;

  @Output() selectionChange = new EventEmitter<{e: Event, lecturerId: number}>();

  constructor(
    public selectedOrg: SelectedOrgService
  ) {}

  onSelectionChange(e: Event, lecturerId: number) {
    this.selectionChange.emit({e, lecturerId});
  }
}
